































import { Component, Prop, Vue } from "vue-property-decorator";

import { ChallengeResult } from "@/models/definitions";

import WrappedImage from "@/components/WrappedImage.vue";

@Component({
  components: {
    WrappedImage,
  },
})
export default class ChallengeCard extends Vue {
  @Prop({ required: true }) readonly challengeResult!: ChallengeResult;

  private readonly MAX_TEXT_LENGTH = 300;

  get challenge() {
    return this.challengeResult.challenge;
  }

  get submission() {
    return this.challengeResult.submission;
  }

  private textOverflows(): boolean {
    return this.challenge.text.length > this.MAX_TEXT_LENGTH;
  }

  private text(): string {
    if (this.textOverflows()) {
      return this.challenge.text.slice(0, this.MAX_TEXT_LENGTH) + "...";
    } else {
      return this.challenge.text;
    }
  }

  get date(): string {
    if (this.challenge.date) {
      return (
        this.challenge.date.getDate() +
        "." +
        (this.challenge.date.getMonth() + 1) +
        "." +
        this.challenge.date.getFullYear()
      );
    }
    return "";
  }
}
